'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reducer = require('./breadcrumbs/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = require('./dropdown/reducer');

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = require('./popup/reducer');

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = require('./slideout-01/reducer');

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = require('./sub-menu/reducer');

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = require('./sub-menu-dropdown/reducer');

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = require('./toggler/reducer');

var _reducer14 = _interopRequireDefault(_reducer13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	breadcrumbs: _reducer2.default,
	dropdown: _reducer4.default,
	popup: _reducer6.default,
	slideout01: _reducer8.default,
	subMenu: _reducer10.default,
	subMenuDropdown: _reducer12.default,
	toggler: _reducer14.default
};